export function isSsrPath(path: string): boolean {
	return path === "/" || /^\/all\/tags\/?$/.test(path) || /^(?:\/(?:tos|privacy)|\/(?:play|drama|u|t)\/[^/]+)\/?$/.test(path);
}

export function canonicalHost(host: string): string {
	if (host === "www.muhaha.ai") return "muhaha.ai";
	const share = /^share(-\w+)?\.muhaha\.ai$/.exec(host);
	return share ? (share[1] ? `www${share[1]}.muhaha.ai` : "muhaha.ai") : host;
}

export function pageCanonicalPath(path: string): string {
	return isSsrPath(path) ? path.replace(/\/+$/, "") || "/" : "/";
}

/** CMS selection is client state; reloading the root loader resets the shared stores. */
export function isExploreSelectionChange(current: URL, next: URL): boolean {
	return current.pathname === next.pathname && (current.pathname === "/" || /^\/t\/[^/]+\/?$/.test(current.pathname))
		&& current.search !== next.search;
}
